<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" fill="none"><path fill-rule="evenodd" d="M11.54.208a.709.709 0 0 1 1.003 0l4.25 4.25a.708.708 0 0 1 0 1.003l-4.25 4.25a.71.71 0 0 1-1.003-1.003l3.75-3.749-3.75-3.748a.71.71 0 0 1 0-1.003Z" clip-rule="evenodd"/><path fill="#fff" fill-rule="evenodd" d="M0 4.96a.708.708 0 0 1 .708-.709h14.875a.708.708 0 0 1 0 1.417H.708A.708.708 0 0 1 0 4.959Z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'icon-arrow'
}
</script>
